// src/app/Components/FontLoader.tsx (or .js)
"use client";

import Head from "next/head";

export default function FontLoader() {
  return (
    <Head>
      {/* Preconnect to Google Fonts */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />

      {/* Load the fonts */}
      <link
        href="https://fonts.googleapis.com/css2?family=Gloock&family=Work+Sans:wght@400;600&display=swap"
        rel="stylesheet"
      />
    </Head>
  );
}
